import { InjectionToken } from '@angular/core';

import { BaasTelemetry, BarCacheStore } from '@lvflanders/bar';

import { BarErrorHandlerHook } from '../hooks/bar-error-handler.hook';
import { BarInitializedHook } from '../hooks/bar-initialized.hook';

// injection token to have same class injected in different ways
export const BAR_GLOBAL_CACHE = new InjectionToken<BarCacheStore>('Global cache store');
export const BAR_USER_CACHE = new InjectionToken<BarCacheStore>('User cache store');
export const BAR_APP_CACHE = new InjectionToken<BarCacheStore>('Application cache store');
export const BAR_MELDINGEN_CACHE = new InjectionToken<BarCacheStore>('Meldingen cache store');

/** @deprecated Use provideBaasInitialized(MyImplementation) with a hook. The token will become internal.
 * function Token for BAR initialized lifecycle hook. */
export const BAR_INITIALIZED = new InjectionToken<BarInitializedHook>('BAR initialized token.');
/** @deprecated Use provideBaasErrorHandler(MyImplementation) with a hook. The token will become internal.
 * Token for BAR error handler hook. */
export const BAR_ERROR_HANDLER = new InjectionToken<BarErrorHandlerHook>('BAR error handling token.');
/** Token used to define whether running under localhost. */
export const BAR_LOCALHOST = new InjectionToken<boolean>('BAR localhost token');
/** Token for Telemetry service. */
export const BAAS_TELEMETRY = new InjectionToken<BaasTelemetry>('BaaS Telemetry service');
